export const currentUser = `query GetCurrentUser($userId: [QueryArgument]) {
  users(id: $userId, limit: 1, group:"subscribers") {
    id
    email
    username
    status
  }
}`
